import { ButtonTypeEnum, ButtonVariantEnum } from '../../enums';
import React, { FunctionComponent } from 'react';

import { ButtonType } from '../../types';

const Button: FunctionComponent<ButtonType> = ({
  title,
  onClick,
  type = ButtonTypeEnum.BUTTON,
  variant = ButtonVariantEnum.PRIMARY,
  className = '',
  disabled = false,
  outline = false,
  showSpinner = false,
  children,
  ...props
}) => {
  return (
    <button
      type={type}
      className={`btn btn${outline ? '-outline' : ''}-${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {showSpinner && <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>}
      {children ? children : title}
    </button>
  );
};

export default Button;
